"use client";
import { cn } from "@/lib/utils";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { ThemeThreeJsWarp } from "./event-theme-threejs-warp";
import { useEffect, useState } from "react";
import { loadAll } from "@tsparticles/all";
import { Container, ISourceOptions } from "@tsparticles/engine";
import { Canvas } from "@react-three/fiber";

export function ThemeParticles({ particlesOptions, emojis, inSheet }: any) {
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadAll(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  const particlesLoaded = async (container?: Container): Promise<void> => {
    // console.log(container);
  };

  const optionsConfetti: any = {
    particles: {
      color: {
        value: ["#ec008c", "#00d2ff", "#FFE000", "#a8ff78", "#00F5A0"],
      },
      move: {
        direction: "bottom",
        enable: true,
        outModes: {
          default: "out",
        },
        size: true,
        speed: {
          min: 1,
          max: 3,
        },
      },
      number: {
        value: 100,
        density: {
          enable: true,
          area: 800,
        },
      },
      opacity: {
        value: 1,
        animation: {
          enable: false,
          startValue: "max",
          destroy: "min",
          speed: 0.3,
          sync: true,
        },
      },
      rotate: {
        value: {
          min: 0,
          max: 360,
        },
        direction: "random",
        move: true,
        animation: {
          enable: true,
          speed: 60,
        },
      },
      tilt: {
        direction: "random",
        enable: true,
        move: true,
        value: {
          min: 0,
          max: 360,
        },
        animation: {
          enable: true,
          speed: 60,
        },
      },
      shape: {
        type: "square",
        options: {},
      },
      size: {
        value: {
          min: 5,
          max: 20,
        },
      },
      roll: {
        darken: {
          enable: true,
          value: 30,
        },
        enlighten: {
          enable: true,
          value: 30,
        },
        enable: true,
        speed: {
          min: 15,
          max: 25,
        },
      },
      wobble: {
        distance: 30,
        enable: true,
        move: true,
        speed: {
          min: -15,
          max: 15,
        },
      },
    },
  };
  const optionsFireworks: ISourceOptions = {
    particles: {
      number: {
        value: 0,
      },
      color: {
        value: [
          "#a8ff78",
          "#1DA1F2",
          "#77FFD2",
          "#FD8112",
          "#FDC830",
          "#ff1e56",
        ],
      },
      shape: {
        type: "circle",
      },
      opacity: {
        value: {
          min: 0,
          max: 1,
        },
        animation: {
          enable: true,
          speed: 50,
          startValue: "max",
          destroy: "min",
        },
      },
      size: {
        value: {
          min: 1,
          max: 8,
        },
      },
      links: {
        enable: false,
      },
      life: {
        duration: {
          sync: true,
          value: 5,
        },
        count: 1,
      },
      move: {
        enable: true,
        speed: {
          min: 5,
          max: 50,
        },
        decay: 0.1,
        direction: "none",
        straight: false,
        outModes: {
          default: "destroy",
          top: "none",
        },
      },
    },
    emitters: [
      {
        life: {
          duration: 0.3,
          delay: 1.2,
        },
        rate: {
          delay: 0.1,
          quantity: 1000,
        },
        size: {
          width: 0,
          height: 0,
        },
      },
      {
        life: {
          duration: 0.2,
          delay: 1,
        },
        rate: {
          delay: 0.2,
          quantity: 500,
        },
        size: {
          width: 0,
          height: 0,
        },
      },
    ],
  };
  const optionsFountain: ISourceOptions = {
    emitters: [
      {
        position: {
          x: 0,
          y: 100,
        },
        rate: {
          quantity: 1,
          delay: 0.15,
        },
      },
      {
        position: {
          x: 100,
          y: 100,
        },
        rate: {
          quantity: 1,
          delay: 0.15,
        },
      },
    ],
    particles: {
      color: {
        value: ["#1E00FF", "#FF0061", "#E1FF00", "#00FF9E"],
      },
      move: {
        decay: 0.08,
        direction: "top",
        enable: true,
        gravity: {
          enable: true,
          acceleration: 50,
        },
        outModes: {
          top: "none",
          default: "destroy",
        },
        speed: {
          min: 10,
          max: 200,
        },
      },

      rotate: {
        value: {
          min: 0,
          max: 10,
        },
        direction: "random",
        animation: {
          enable: true,
          speed: 10,
        },
      },

      size: {
        value: 50,
        animation: {
          enable: true,
          startValue: "min",
          count: 1,
          speed: 10,
          sync: true,
        },
      },
      shape: {
        type: ["circle", "square"],
      },
    },
  };
  const optionsCollision: ISourceOptions = {
    duration: 0,
    fpsLimit: 60,

    particles: {
      bounce: {
        horizontal: {
          value: 1,
        },
        vertical: {
          value: 1,
        },
      },
      collisions: {
        absorb: {
          speed: 2,
        },
        bounce: {
          horizontal: {
            value: 1,
          },
          vertical: {
            value: 1,
          },
        },
        enable: true,
        maxSpeed: 50,
        mode: "bounce",
        overlap: {
          enable: true,
          retries: 0,
        },
      },
      color: {
        value: "#000000",
      },

      move: {
        angle: {
          offset: 0,
          value: 90,
        },
        center: {
          x: 50,
          y: 50,
          mode: "percent",
          radius: 0,
        },
        decay: 0,
        direction: "none",
        drift: 0,
        enable: true,
        gravity: {
          acceleration: 9.81,
          enable: false,
          inverse: false,
          maxSpeed: 10,
        },
        path: {
          clamp: true,
          delay: {
            value: 0,
          },
          enable: false,
          options: {},
        },
        outModes: {
          default: "out",
        },
        random: false,
        size: false,
        speed: 2,

        straight: false,
        trail: {
          enable: false,
          length: 10,
          fill: {},
        },
        vibrate: false,
        warp: false,
      },
      number: {
        limit: {
          mode: "delete",
          value: 0,
        },
        value: 10,
      },

      shape: {
        close: true,
        fill: true,
        type: ["emoji"],
        options: {
          emoji: {
            value: emojis,
          },
        },
      },
      size: {
        value: 100,
        animation: {
          count: 0,
          enable: false,
          speed: 5,
          decay: 0,
          delay: 0,
          sync: false,
          mode: "auto",
          startValue: "random",
          destroy: "none",
        },
      },
      zIndex: {
        value: 0,
        opacityRate: 1,
        sizeRate: 1,
        velocityRate: 1,
      },
    },
  };
  const optionsMessy: any = {
    fpsLimit: 60,

    interactivity: {
      detect_on: "canvas",
      events: {
        onClick: { enable: true, mode: "push" },
      },
      modes: {
        push: { quantity: 1 },
      },
    },
    particles: {
      color: { value: "random" },
      links: {
        color: "random",
        distance: 150,
        enable: false,
        opacity: 1,
        width: 1,
      },
      move: {
        attract: { enable: false, rotateX: 600, rotateY: 1200 },
        bounce: false,
        direction: "none",
        enable: true,
        out_mode: "out",
        random: false,
        speed: 3,
        straight: false,
      },
      rotate: {
        animation: {
          enable: true,
          speed: 5,
          sync: false,
        },
      },
      number: { density: { enable: true, area: 800 }, value: 50 },
      opacity: {
        animation: { enable: true, minimumValue: 0.5, speed: 1, sync: false },
        random: false,
        value: 1,
      },
      shape: {
        type: ["emoji"],
        options: {
          emoji: {
            particles: {
              size: {
                value: 40,
              },
            },
            value: emojis,
          },
        },
      },
      size: {
        anim: { enable: true, minimumValue: 8, speed: 20, sync: false },
        random: { minimumValue: 8, enable: true },
        value: 32,
      },
    },
  };
  const optionsSnow: any = {
    autoPlay: true,

    clear: true,
    delay: 0,

    duration: 0,
    fpsLimit: 60,

    particles: {
      bounce: {
        horizontal: {
          value: 1,
        },
        vertical: {
          value: 1,
        },
      },
      collisions: {
        absorb: {
          speed: 2,
        },
        bounce: {
          horizontal: {
            value: 1,
          },
          vertical: {
            value: 1,
          },
        },
        enable: false,
        maxSpeed: 50,
        mode: "bounce",
        overlap: {
          enable: true,
          retries: 0,
        },
      },
      color: {
        value: "#fff",
        animation: {
          h: {
            count: 0,
            enable: false,
            speed: 1,
            decay: 0,
            delay: 0,
            sync: true,
            offset: 0,
          },
          s: {
            count: 0,
            enable: false,
            speed: 1,
            decay: 0,
            delay: 0,
            sync: true,
            offset: 0,
          },
          l: {
            count: 0,
            enable: false,
            speed: 1,
            decay: 0,
            delay: 0,
            sync: true,
            offset: 0,
          },
        },
      },

      groups: {},
      move: {
        angle: {
          offset: 0,
          value: 90,
        },
        attract: {
          distance: 200,
          enable: false,
          rotate: {
            x: 3000,
            y: 3000,
          },
        },
        center: {
          x: 50,
          y: 50,
          mode: "percent",
          radius: 0,
        },
        decay: 0,
        distance: {},
        direction: "bottom",
        drift: 0,
        enable: true,
        gravity: {
          acceleration: 9.81,
          enable: false,
          inverse: false,
          maxSpeed: 50,
        },
        path: {
          clamp: true,
          delay: {
            value: 0,
          },
          enable: false,
          options: {},
        },
        outModes: {
          default: "out",
        },
        random: false,
        size: false,
        speed: 2,
        spin: {
          acceleration: 0,
          enable: false,
        },
        straight: true,
        trail: {
          enable: false,
          length: 10,
          fill: {},
        },
        vibrate: false,
        warp: false,
      },
      number: {
        density: {
          enable: true,
          width: 1920,
          height: 1080,
        },
        limit: {
          mode: "delete",
          value: 0,
        },
        value: 400,
      },
      opacity: {
        value: 1,
        animation: {
          count: 0,
          enable: false,
          speed: 2,
          decay: 0,
          delay: 0,
          sync: false,
          mode: "auto",
          startValue: "random",
          destroy: "none",
        },
      },
      reduceDuplicates: false,
      shadow: {
        blur: 0,
        color: {
          value: "#000",
        },
        enable: false,
        offset: {
          x: 0,
          y: 0,
        },
      },
      shape: {
        close: true,
        fill: true,
        options: {},
        type: "circle",
      },
      size: {
        value: 10,
        animation: {
          count: 0,
          enable: false,
          speed: 5,
          decay: 0,
          delay: 0,
          sync: false,
          mode: "auto",
          startValue: "random",
          destroy: "none",
        },
      },
      stroke: {
        width: 0,
      },
      zIndex: {
        value: {
          min: 0,
          max: 100,
        },
        opacityRate: 10,
        sizeRate: 10,
        velocityRate: 10,
      },
      destroy: {
        bounds: {},
        mode: "none",
        split: {
          count: 1,
          factor: {
            value: 3,
          },
          rate: {
            value: {
              min: 4,
              max: 9,
            },
          },
          sizeOffset: true,
        },
      },
      roll: {
        darken: {
          enable: false,
          value: 0,
        },
        enable: false,
        enlighten: {
          enable: false,
          value: 0,
        },
        mode: "vertical",
        speed: 25,
      },
      tilt: {
        value: 0,
        animation: {
          enable: false,
          speed: 0,
          decay: 0,
          sync: false,
        },
        direction: "clockwise",
        enable: false,
      },
      twinkle: {
        lines: {
          enable: false,
          frequency: 0.05,
          opacity: 1,
        },
        particles: {
          enable: false,
          frequency: 0.05,
          opacity: 1,
        },
      },
      wobble: {
        distance: 10,
        enable: true,
        speed: {
          angle: 10,
          move: 10,
        },
      },
      life: {
        count: 0,
        delay: {
          value: 0,
          sync: false,
        },
        duration: {
          value: 0,
          sync: false,
        },
      },
      rotate: {
        value: 0,
        animation: {
          enable: false,
          speed: 0,
          decay: 0,
          sync: false,
        },
        direction: "clockwise",
        path: false,
      },
      orbit: {
        animation: {
          count: 0,
          enable: false,
          speed: 1,
          decay: 0,
          delay: 0,
          sync: false,
        },
        enable: false,
        opacity: 1,
        rotation: {
          value: 45,
        },
        width: 1,
      },
      links: {
        blink: false,
        color: {
          value: "#fff",
        },
        consent: false,
        distance: 100,
        enable: false,
        frequency: 1,
        opacity: 1,
        shadow: {
          blur: 5,
          color: {
            value: "#000",
          },
          enable: false,
        },
        triangles: {
          enable: false,
          frequency: 1,
        },
        width: 1,
        warp: false,
      },
    },
  };

  return (
    <div
      className={cn(
        " flex fade-in top-0 min-h-full h-full w-full object-cover -z-50 background-force-cover",
        inSheet ? "absolute" : "fixed",
      )}
    >
      {init && particlesOptions != "warp" && (
        <Particles
          id="tsparticles"
          className="w-screen h-screen"
          particlesLoaded={particlesLoaded}
          options={
            (particlesOptions == "fountain" && optionsFountain) ||
            (particlesOptions == "fireworks" && optionsFireworks) ||
            (particlesOptions == "collision" && optionsCollision) ||
            (particlesOptions == "messy" && optionsMessy) ||
            (particlesOptions == "confetti" && optionsConfetti) ||
            (particlesOptions == "snow" && optionsSnow) ||
            {}
          }
        />
      )}
      {particlesOptions == "warp" && (
        <Canvas
          camera={{
            fov: 100,
            near: 0.1,
            far: 200,
          }}
        >
          <ThemeThreeJsWarp />
        </Canvas>
      )}
    </div>
  );
}
